'use strict';

bbw.directive.bbwBindMsg = ['bbw.MsgToHtmlSvc', function(msgToHtmlSvc) {

    return {
        scope: {
            value: '=bbwBindMsg',
            rawHtml: '=rawHtml'
        },
        link: function(scope, element, attr) {
            function update(input) {
                element.html(msgToHtmlSvc.msgToHtml(input, scope.rawHtml));
            }

            scope.$watch('value', update);
            scope.$watch('rawHtml', function(newValue, oldValue) {
                if (!!newValue != !!oldValue) {
                    update(scope.value);
                }
            });
            update(scope.value);
        }
    }
}];
